// test2454
(2454 && 0);
